<template>
  <div
    class="contents"
    :class="{'height-100': !isHovering(model) && !activated}"
    @mouseenter="hover = true"
    @mouseleave="hover = false">
    <div
      v-if="!isHovering(model) && !activated"
      :class="[{'disabled': disable, 'secondary__red-border': error}, div_class + ' justify-center hover', block_color]">
      <div
        v-if="error"
        class="secondary__red--text"
        :class="text_div_class"
        @click="activate">
        {{ $t('Tenders.YouMustFillVField') }}
      </div>
      <sButton
        v-if="!disable"
        v-show="hover && !error"
        ref="add_data_btn"
        class="px-2 mx-auto"
        icon="plus"
        small
        type="text"
        @click="activate">
        <span
          class="h11-links secondary__green_not_active--text"> {{ label ? label : $t('Tenders.AddData') }}</span>
      </sButton>
    </div>
    <div
      v-else
      class="activator"
      :class="[{'disabled ' : disable}, block_color]">
      <template v-if="menu">
        <sPopover
          ref="hoverAddMenu"
          v-model="edit"
          :disabled="disable"
          placement="center"
          popper-class="hover-menu"
          transition="s-zoom-in-top"
          :width="menu_width">
          <slot
            :activ="edit"
            :deactivate="deactivate"
            name="menu"/>
          <template #reference>
            <div
              :class="{'pointer' : !disable, [text_div_class]: true}">
              <slot
                :deactivate="deactivate"
                name="activator">
                {{ formatValue(model) }} {{ suffix }}
              </slot>
            </div>
          </template>
        </sPopover>
      </template>
      <template v-else>
        <slot
          v-if="!edit"
          :activate="activate"
          name="activator">
          <div
            :class="text_div_class"
            @click="activate">
            {{ formatValue(model) }} {{ suffix }}
          </div>
        </slot>
        <slot
          v-else
          :deactivate="deactivate"
          name="editor">
          <div :class="div_class"/>
        </slot>
      </template>
    </div>
  </div>
</template>
<script>
import { eventBus } from '@/main'
import { modalMixin } from 'mixins'

export default {
  name: 'hoverAddData',
  mixins: [modalMixin],
  props: {
    label: String,
    value: [String, Number, Object, Array, Boolean],
    menu: Boolean,
    menu_width: [String, Number],
    left: Boolean,
    bottom: Boolean,
    suffix: [String, Object, Number],
    formatter: Function,
    text_class: String,
    disable: Boolean,
    with_common_class: Boolean,
    full_height: Boolean,
    color: String,
    error: [String, Boolean]
  },
  data() {
    return {
      activated: false,
      hover: false,
      edit: false,
      timeout: 0,
      div_class: ' activator flex align-center justify-start flex-grow-1 text-start '
    }
  },
  mounted() {
    if (this.$root.$eventBus) {
      this.$root.$eventBus.$on('resizeWindow', this.adjustMenuPosition)
    } else if (typeof eventBus !== 'undefined') {
      eventBus.$on('resizeWindow', this.adjustMenuPosition)
    }
  },
  beforeDestroy() {
    if (this.$root.$eventBus) {
      this.$root.$eventBus.$off('resizeWindow', this.adjustMenuPosition)
    } else if (typeof eventBus !== 'undefined') {
      eventBus.$off('resizeWindow', this.adjustMenuPosition)
    }
  },
  computed: {
    block_color() {
      return this.color ? this.color : this.disable ? 'secondary__green_chosen' : ''
    },
    text_div_class() {
      let div = this.div_class + 'py-3 pl-6 pr-3'
      return this.with_common_class ? this.text_class + div : this.text_class ? this.text_class + ' activator  ' : div
    },
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update:value', value)
      }
    }
  },
  methods: {
    adjustMenuPosition() {
      const menu = this.$refs.hoverAddMenu
      if (this.edit && menu) {
        this.$nextTick(() => {
          menu.updatePopper()
        })
      }
    },
    formatValue(val) {
      if (this.formatter) {
        return this.formatter(val)
      }
      return val
    },
    activate() {
      if (this.disable) {
        return
      }
      setTimeout(() => {
        let field = document.querySelector('.textarea input')
        field?.focus()
        field?.select()
      },50)
      setTimeout(() => {
        this.edit = true
      }, 10)

      this.activated = true
      this.$emit('action')
    },
    deactivate() {
      this.edit = false
      this.activated = this.isHovering(this.model)
    },
    isHovering(val) {
      const isNullOrFalse = !val && val !== false
      const isObjectEmpty = val && typeof val === 'object' && !Object.keys(val).length

      return !(isNullOrFalse || isObjectEmpty)
    },
  },
  watch: {
    edit(value) {
      if (!value) {
        this.deactivate()
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.activator {
  min-height: 100% !important;
  width: 100%;
  // min-height: inherit;
  .activator {
    width: 100%;
  }
  min-height: 40px;
  &.hover .v-btn{
    color: var(--v-secondary__green_not_active-base) !important;
    &:before {
      background-color: transparent;
    }
  }
}
::v-deep .s-popover__reference-wrapper {
  width: 100%;
}
</style>

<style lang="scss">
.hover-menu.s-popover {
  border: 1px solid var(--v-main__green-base);
  border-radius: 8px !important;
  max-height: 100% !important;
}
</style>
